<div class="three-d-map-seats-list-item">
  <div class="three-d-map-seats-list-item-header">
    <span class="three-d-map-seats-list-item-header-icon">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_380_2455"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_380_2455)">
          <path
            d="M3.33333 14C3.14444 14 2.98611 13.9361 2.85833 13.8083C2.73056 13.6806 2.66667 13.5222 2.66667 13.3333V11.3333C2.66667 10.9667 2.79722 10.6528 3.05833 10.3917C3.31944 10.1306 3.63333 10 4 10H12C12.3667 10 12.6806 10.1306 12.9417 10.3917C13.2028 10.6528 13.3333 10.9667 13.3333 11.3333V13.3333C13.3333 13.5222 13.2694 13.6806 13.1417 13.8083C13.0139 13.9361 12.8556 14 12.6667 14C12.4778 14 12.3194 13.9361 12.1917 13.8083C12.0639 13.6806 12 13.5222 12 13.3333V11.3333H4V13.3333C4 13.5222 3.93611 13.6806 3.80833 13.8083C3.68056 13.9361 3.52222 14 3.33333 14ZM3 9.33333C2.72222 9.33333 2.48611 9.23611 2.29167 9.04167C2.09722 8.84722 2 8.61111 2 8.33333C2 8.05556 2.09722 7.81944 2.29167 7.625C2.48611 7.43056 2.72222 7.33333 3 7.33333C3.27778 7.33333 3.51389 7.43056 3.70833 7.625C3.90278 7.81944 4 8.05556 4 8.33333C4 8.61111 3.90278 8.84722 3.70833 9.04167C3.51389 9.23611 3.27778 9.33333 3 9.33333ZM4.66667 9.33333V3.33333C4.66667 2.96667 4.79722 2.65278 5.05833 2.39167C5.31944 2.13056 5.63333 2 6 2H10C10.3667 2 10.6806 2.13056 10.9417 2.39167C11.2028 2.65278 11.3333 2.96667 11.3333 3.33333V9.33333H4.66667ZM13 9.33333C12.7222 9.33333 12.4861 9.23611 12.2917 9.04167C12.0972 8.84722 12 8.61111 12 8.33333C12 8.05556 12.0972 7.81944 12.2917 7.625C12.4861 7.43056 12.7222 7.33333 13 7.33333C13.2778 7.33333 13.5139 7.43056 13.7083 7.625C13.9028 7.81944 14 8.05556 14 8.33333C14 8.61111 13.9028 8.84722 13.7083 9.04167C13.5139 9.23611 13.2778 9.33333 13 9.33333ZM6 8H10V3.33333H6V8Z"
            fill="#060606"
          />
        </g>
      </svg>
    </span>
    <div class="three-d-map-seats-list-item-header-text">
      <p>{{ seat.block }}</p>
      <p>{{ seat.seat }}</p>
    </div>
  </div>
  <p class="">RD$ {{ seat.price }}</p>
</div>
